import { BasketPlusOutlineIcon } from './BasketPlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id DC1E93FF-94C4-4B14-9152-ADDE374A44BB
 * name basket-plus-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-plus-outline.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketPlusOutlineIcon = BasketPlusOutlineIcon;
export default ShoppingBasketPlusOutlineIcon